import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ActionGrid from "../actionGrid/ActionGrid"
import ActionGridSpaceSettings from "../actionGrid/ActionGridSpaceSettings"

export default function DialogEditActionGrid ({ actionGridId, open, handleClose, fromEditAction }) {
    return (
        <>
            <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className="mx_width">
                <DialogTitle id="form-dialog-title">{actionGridId ? "Update" : "Create"} Action Grid settings</DialogTitle>
                <DialogContent>

                    {fromEditAction === 'topBottomSpace' ? <ActionGridSpaceSettings actionGridId={actionGridId} handleClose={handleClose} fromEditAction={fromEditAction} /> : <ActionGrid actionGridId={actionGridId} handleClose={handleClose} fromEditAction={fromEditAction} />}

                </DialogContent>
            </Dialog>
        </>
    );
}